<template>
  <v-content class="mt-0">
    <v-container fluid>
      <v-row wrap>
        <template v-for="(driver, index) in drivers">
          <v-col cols="12" sm="6" md="4" lg="3" :key="`${driver.id}-flex`">
            <mini-driver-creator
              v-on:delete="remove(index)"
              :initial="driver"
            ></mini-driver-creator>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-content>
</template>    

<script>
import MiniDriverCreator from "./MiniDriverCreator";

export default {
  components: {
    MiniDriverCreator,
  },
  methods: {
    remove(index) {
      this.$store.commit("removeDriver", index);
    },
  },
  computed: {
    drivers() {
      return this.$store.state.drivers;
    },
  },
};
</script>